import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class GenericPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Poppins.Regular_400,
      FONT.Poppins.Medium_500,
      FONT.Poppins.SemiBold_600,
      FONT.Poppins.Bold_700,
      FONT.Poppins.ExtraBold_800
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/xbo1edl.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
